import cardAmexUrl from '@/assets/icon/card_types/card_AMEX.svg'
import cardVisaUrl from '@/assets/icon/card_types/card_Visa.svg'
import cardMastercardUrl from '@/assets/icon/card_types/card_MasterCard.svg'
import cardDiscoverUrl from '@/assets/icon/card_types/card_Discover.svg'
import { Icon } from '@/components/Icon'
import styles from './CardIcon.module.css'
import cx from 'classnames'
import { match } from '@/utils/pattern-match-util'

interface CardIconProps {
  brand: string
  isSkeleton?: boolean
  size?: 'sm' | 'base' | 'lg'
}

/**
 * Card icon based on the brand.
 */
export function CardIcon({ isSkeleton, brand, size = 'base' }: CardIconProps) {
  const url = getCardIconUrl(brand)
  const sizeClass = match(size, {
    sm: styles.sm,
    base: '',
    lg: styles.lg,
  })

  if (!url) {
    return (
      <div className={cx(styles.root, sizeClass)}>
        <Icon skeleton={isSkeleton} name="card" />
      </div>
    )
  }

  return (
    <img
      className={cx(styles.root, sizeClass)}
      src={url}
      alt={`${brand} logo`}
      aria-hidden
    />
  )
}

function getCardIconUrl(brand: string) {
  brand = brand.toLowerCase()
  switch (true) {
    case brand === 'visa':
      return cardVisaUrl
    case brand === 'mastercard':
      return cardMastercardUrl
    case brand.includes('discover'):
      return cardDiscoverUrl
    case brand.includes('amex'):
    case brand.includes('american'):
      return cardAmexUrl
    default:
      return null
  }
}
